/* ==========================================================================
   Scroll Reveal – globaler "Erscheinen"-Effekt (wie beim Radiance-Theme)
   Einmal im Layout eingebunden, wirkt das Script automatisch auf JEDE
   Section auf JEDER Seite des Themes – ohne dass einzelne Section-Dateien
   angepasst werden müssen. Neu per AJAX nachgeladene Inhalte (Cart-Drawer,
   Quick-View, Suchergebnisse, "mehr laden" …) werden automatisch mit
   erfasst.
   ========================================================================== */

(function () {
  'use strict';

  // Falls der Browser kein IntersectionObserver kann: alles normal zeigen,
  // keine Animation erzwingen.
  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.add('sr-ready', 'sr-anim-on');
    return;
  }

  // Mindestgröße (px), ab der ein Bild als "richtiges" Bild zählt – kleine
  // Icons/Logos (z. B. Zahlungssymbole, Social-Icons) werden nicht animiert.
  var MIN_MEDIA_SIZE = 120;

  // Ab welchem Anteil der Textfläche ein Bild als "mit Text überlagert"
  // gilt (und deshalb fest eingeblendet bleibt statt zu animieren).
  var OVERLAY_THRESHOLD = 0.3;

  var MEDIA_SELECTOR = 'img, picture, video';
  var TEXT_SELECTOR = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p', 'blockquote', 'li',
    'a.button', '.button', '.btn', 'button:not([data-sr-skip])',
    'figcaption'
  ].join(',');

  // Sections, die den Effekt NICHT bekommen sollen (Header/Announcement-Bar
  // ist immer sichtbar bzw. sticky – ein "Erscheinen" wirkt dort seltsam).
  function isExcludedSection(section) {
    if (section.closest('header')) return true;
    var id = (section.id || '') + ' ' + (section.className || '');
    return /header|announcement/i.test(id);
  }

  // Merkt sich zu jedem Text-Element die anderen Text-Elemente derselben
  // Section, damit ein ganzer Textblock gemeinsam erscheint statt
  // Element für Element.
  var textGroupOf = new WeakMap();

  var mediaObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealMedia(entry.target);
          mediaObserver.unobserve(entry.target);
        }
      });
    },
    { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
  );

  var textObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var group = textGroupOf.get(entry.target) || [entry.target];
        group.forEach(function (el) {
          reveal(el);
          textObserver.unobserve(el);
        });
      });
    },
    { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
  );

  function reveal(el) {
    el.classList.add('is-revealed');
  }

  // Manche Elemente positionieren sich selbst über "transform" (z. B. mittig
  // zentrierte Slider-Pfeile mit "top: 50%; transform: translateY(-50%)").
  // Würden wir denen zusätzlich unsere Bewegungs-Animation geben, würde
  // "transform: none" beim Einblenden ihre eigene Positionierung zerstören.
  // Solche Elemente bekommen deshalb nur die reine Opacity-Animation.
  function hasOwnTransform(el) {
    var t = window.getComputedStyle(el).transform;
    return t && t !== 'none';
  }

  // Fügt die passenden Reveal-Klassen hinzu: immer die Opacity-Animation
  // (.sr-fade), zusätzlich die Bewegung (.sr-reveal) nur, wenn das Element
  // nicht schon selbst eine transform-Positionierung besitzt.
  function applyReveal(el, extraClass) {
    el.classList.add('sr-fade');
    if (extraClass) el.classList.add(extraClass);
    if (!hasOwnTransform(el)) {
      el.classList.add('sr-reveal');
    }
  }

  // Bilder/Videos erst einblenden, sobald sie tatsächlich geladen sind –
  // sonst steht die Opacity-Animation schon fertig, bevor die Bilddaten
  // überhaupt da sind, und das Bild scheint "plötzlich" aufzutauchen statt
  // flüssig einzublenden.
  function revealMedia(el) {
    function trigger() {
      requestAnimationFrame(function () {
        reveal(el);
      });
    }

    if (el.tagName === 'IMG') {
      if (el.complete && el.naturalWidth > 0) {
        trigger();
      } else {
        el.addEventListener('load', trigger, { once: true });
        el.addEventListener('error', trigger, { once: true });
      }
    } else if (el.tagName === 'VIDEO') {
      if (el.readyState >= 2) {
        trigger();
      } else {
        el.addEventListener('loadeddata', trigger, { once: true });
      }
    } else if (el.tagName === 'PICTURE') {
      var img = el.querySelector('img');
      if (img && !(img.complete && img.naturalWidth > 0)) {
        img.addEventListener('load', trigger, { once: true });
        img.addEventListener('error', trigger, { once: true });
      } else {
        trigger();
      }
    } else {
      trigger();
    }
  }

  function isInInitialViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function overlapRatio(rectA, rectB) {
    var xOverlap = Math.max(0, Math.min(rectA.right, rectB.right) - Math.max(rectA.left, rectB.left));
    var yOverlap = Math.max(0, Math.min(rectA.bottom, rectB.bottom) - Math.max(rectA.top, rectB.top));
    var overlapArea = xOverlap * yOverlap;
    var areaB = rectB.width * rectB.height;
    return areaB > 0 ? overlapArea / areaB : 0;
  }

  // Nur die jeweils äußersten Treffer behalten, damit z. B. nicht sowohl
  // ein umschließendes Element als auch dessen Kind-Absätze doppelt
  // animiert werden.
  function topLevelOnly(elements) {
    var set = new Set(elements);
    return elements.filter(function (el) {
      var parent = el.parentElement;
      while (parent) {
        if (set.has(parent)) return false;
        parent = parent.parentElement;
      }
      return true;
    });
  }

  function setStagger(elements) {
    // Elemente mit demselben direkten Elternelement bekommen eine leicht
    // gestaffelte Verzögerung (z. B. mehrere Spalten/Karten nebeneinander).
    var groups = new Map();
    elements.forEach(function (el) {
      var parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach(function (group) {
      group.forEach(function (el, index) {
        el.style.setProperty('--sr-delay', Math.min(index * 0.08, 0.4) + 's');
      });
    });
  }

  function processSection(section) {
    if (isExcludedSection(section) || section.dataset.srProcessed) return;
    section.dataset.srProcessed = 'true';

    var mediaCandidates = Array.prototype.filter.call(
      section.querySelectorAll(MEDIA_SELECTOR),
      function (el) {
        if (el.closest('.sr-fade, .sr-reveal')) return false;

        // Hover-/Touch-Vorschaubilder (z. B. das zweite Produktbild oder ein
        // Vorschau-Video, das per CSS nur bei :hover eingeblendet wird)
        // starten mit opacity: 0 und werden über Mausereignisse gesteuert,
        // nicht über Scrollen. Werden sie hier trotzdem "enthüllt", bleibt
        // die Opacity dauerhaft auf 1 stehen und das letzte Video-/Bild-Frame
        // "klebt" sichtbar über dem eigentlichen Produktbild. Deshalb
        // bleiben sie vom Scroll-Reveal komplett unangetastet.
        if (parseFloat(window.getComputedStyle(el).opacity) === 0) return false;

        var rect = el.getBoundingClientRect();
        return rect.width >= MIN_MEDIA_SIZE && rect.height >= MIN_MEDIA_SIZE;
      }
    );

    var textCandidates = topLevelOnly(
      Array.prototype.filter.call(section.querySelectorAll(TEXT_SELECTOR), function (el) {
        return !el.closest('.sr-fade, .sr-reveal') && el.textContent.trim() !== '';
      })
    );

    // Bilder mit Text-Overlay erkennen: überlappt ein Text-Kandidat spürbar
    // mit einem Bild, bleibt das Bild fest sichtbar und nur der Text
    // animiert.
    var textRects = textCandidates.map(function (el) {
      return el.getBoundingClientRect();
    });

    var mediaToAnimate = mediaCandidates.filter(function (media) {
      var mediaRect = media.getBoundingClientRect();
      return !textRects.some(function (textRect) {
        return overlapRatio(mediaRect, textRect) > OVERLAY_THRESHOLD;
      });
    });

    setStagger(mediaToAnimate);

    mediaToAnimate.forEach(function (el) {
      applyReveal(el, 'sr-reveal--image');
      if (isInInitialViewport(el)) {
        revealMedia(el);
      } else {
        mediaObserver.observe(el);
      }
    });

    // Alle Text-Elemente einer Section bilden EINEN Block: sie bekommen
    // dieselbe Gruppe zugewiesen und erscheinen gemeinsam, sobald der
    // Block ins Bild scrollt – nicht nacheinander versetzt.
    textCandidates.forEach(function (el) {
      applyReveal(el, 'sr-reveal--text');
      textGroupOf.set(el, textCandidates);
    });

    if (textCandidates.length > 0) {
      var anyTextAlreadyVisible = textCandidates.some(isInInitialViewport);
      if (anyTextAlreadyVisible) {
        // Liegt (auch nur teilweise) schon im sichtbaren Bereich beim
        // Laden: der ganze Block wird sofort ohne Animation gezeigt,
        // statt ihn optisch aufzuspalten.
        textCandidates.forEach(reveal);
      } else {
        textCandidates.forEach(function (el) {
          textObserver.observe(el);
        });
      }
    }
  }

  function scan(root) {
    var sections = root.matches && root.matches('.shopify-section')
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('.shopify-section'));

    // Fallback für Templates ohne .shopify-section-Wrapper (z. B. Apps,
    // eigene Snippets): Hauptinhalt als eine große "Section" behandeln.
    if (sections.length === 0 && root === document.body) {
      var main = document.querySelector('main');
      if (main) sections = [main];
    }

    sections.forEach(processSection);
  }

  function init() {
    scan(document.body);
    document.documentElement.classList.add('sr-ready');

    // Zwei Frames warten, bevor Übergänge aktiviert werden – so wird der
    // Ausgangszustand einmal ohne Animation gerendert (kein Aufblitzen).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.add('sr-anim-on');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Nachträglich eingefügte Inhalte (Cart-Drawer, Quick View, Such-/
  // Filterergebnisse, "Mehr laden" …) automatisch mit erfassen.
  var mutationTimeout;
  new MutationObserver(function (mutations) {
    var hasNewElements = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (!hasNewElements) return;
    clearTimeout(mutationTimeout);
    mutationTimeout = setTimeout(function () {
      scan(document.body);
    }, 50);
  }).observe(document.body, { childList: true, subtree: true });
})();
